import { render } from "./NotificationBar.vue?vue&type=template&id=2ca7fb37&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=2ca7fb37&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca7fb37"]])

export default __exports__